import { TableCell } from '@mui/material'
import React from 'react'
import MyTable from '../UI/table/MyTable'
import PackItem from './PackItem'
import MyTableNotFound from '../UI/table/MyTableNotFound'
import MySpiner from '../UI/spiner/MySpiner'

const PackTable = ({ packs, count, offset, setOffset, limit, setLimit, loading }) => {
  return (
    <MyTable
        head={
            <>
                <TableCell align="center">ID</TableCell>
                <TableCell align="center">Товар</TableCell>
                <TableCell align="center">Серія</TableCell>
                {/* <TableCell align="center">Товари</TableCell> */}
                <TableCell align="center">Кількість товару</TableCell>
                <TableCell align="center">ID замовлення в CRM</TableCell>
                <TableCell align="center">Тип контракту</TableCell>
                <TableCell align="center">Тип партії</TableCell>
                <TableCell align="center">Пароль</TableCell>
                <TableCell align="center">Дії</TableCell>
            </>
        }
        body={
            packs && packs.length > 0 ?
                packs.map(pack => 
                    <PackItem
                        key={pack.id}
                        pack={pack} 
                    />
                )
            : 
                <MyTableNotFound
                    text='Партій не знайдено' 
                    columns={6}
                />
        }
        name='партій'
        count={count}
        limit={limit}
        setLimit={setLimit}
        offset={offset}
        setOffset={setOffset}
        loading={loading}
    />
  )
}

export default PackTable